import { render, staticRenderFns } from "./transferRecord.vue?vue&type=template&id=4fb1dd4d&scoped=true"
import script from "./transferRecord.vue?vue&type=script&lang=js"
export * from "./transferRecord.vue?vue&type=script&lang=js"
import style0 from "./transferRecord.vue?vue&type=style&index=0&id=4fb1dd4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb1dd4d",
  null
  
)

export default component.exports